export const AuthRoot = 'auth';

export const AuthRoutes = {
  LOGIN: 'login',
  REGISTER: 'register',
};
